<template>
  <div ref="tab" class="leavecontent">
    <div class="headers" :class="'headers-background-'+leaveInfo.applyStatus">
      <headers
        :headInfo="{headUrl: leaveInfo.dingDingPhotoPath, dingdingUserId:leaveInfo.currentApplyDingDingId, userName: leaveInfo.currentApplyEmployeeName, approver: leaveInfo.nextApprover, approvalState: leaveInfo.applyStatus }"
      ></headers>
    </div>
    <div ref="leave_tab" class="leave-tab">
      <tab :tabconfig="tabconfig"></tab>
    </div>
    <div class="mian">
      <div class="leave-info d_jump">
        <div class="leave-info-box">
          <div class="leave-info-label">申请单号</div>
          <div class="leave-info-content">{{leaveInfo.applyID}}</div>
        </div>
        <div class="leave-info-box">
          <div class="leave-info-label">请假时间</div>
          <div
            class="leave-info-content"
          >{{leaveInfo.restStartDate+" "+leaveInfo.restStartTime+"至"+leaveInfo.restEndDate+" "+leaveInfo.restEndTime}}</div>
        </div>
        <div class="leave-info-box">
          <div class="leave-info-label">请假时长</div>
          <div class="leave-info-content">共 {{leaveInfo.restTime/8}} 天</div>
        </div>
        <div class="leave-info-box">
          <div class="leave-info-label">请假类型</div>
          <div class="leave-info-content">
            <span>{{leaveInfo.restTypeID}}</span>
            <span
              v-if="leaveInfo.restSubTypeID&&leaveInfo.restSubTypeID.length>0"
            >({{leaveInfo.restSubTypeID}})</span>
          </div>
        </div>
        <div class="leave-info-box">
          <div class="leave-info-label">请假事由</div>
          <div class="leave-info-content">{{leaveInfo.restReason}}</div>
        </div>
        <div class="leave-info-box">
          <div class="leave-info-label">近期请假详情</div>
          <div class="leave-info-content">
            <Table border :columns="columns" :data="leaveInfo.recentLeaveApply">
              <template slot-scope="{ row }" slot="restTime">
                <span>{{ row.restTime/8 }}天</span>
              </template>
              <template slot-scope="{ row }" slot="applyStatus">
                <span>{{ applyState[row.applyStatus] }}</span>
              </template>
            </Table>
          </div>
        </div>
        <div class="leave-info-box">
          <div class="leave-info-label">附件</div>
          <div class="leave-info-content">
            <filebox message="暂无附件" :fileInfo="fileInfo"></filebox>
          </div>
        </div>
      </div>
      <div class="process d_jump">
        <process
          :approvalList="leaveInfo.approvalList"
          :applyEmployeeID="leaveInfo.applyEmployeeID"
        ></process>
      </div>
    </div>
    <div class="leave-foot">
      <exefoot
        :paramInfo="{...paramInfo,approveStep:leaveInfo.nextApproveStep}"
        v-if="leaveInfo.nextApproverId&&leaveInfo.nextApproverId.indexOf(userInfo.employeeID)>-1&&leaveInfo.applyStatus=='SUBMIT'"
      ></exefoot>
      <selffoot
        :paramInfo="paramInfo"
        :urgeInfo="{approverUserId:leaveInfo.nextApproverUserId,applyEmployeeName:leaveInfo.currentApplyEmployeeName, applyTypeName:'请假申请',url:'leave'}"
        v-else-if="leaveInfo.applyEmployeeID==userInfo.employeeID&&leaveInfo.applyStatus=='SUBMIT'"
      ></selffoot>
      <passfoot :paramInfo="paramInfo" v-else></passfoot>
    </div>
  </div>
</template> 
<script>
import Vue from "vue";
import VueTouch from "vue-touch";
Vue.use(VueTouch, { name: "v-touch" });
import headers from "@/components/Approval/ApprovalHead/index";
import process from "@/components/Approval/ApprovalProcess/index";
import exefoot from "@/components/Approval/ApprovalFoot/approvalExeFoot";
import selffoot from "@/components/Approval/ApprovalFoot/approvalSelfFoot";
import passfoot from "@/components/Approval/ApprovalFoot/approvalPassFoot";
import tab from "@/components/Share/Tab";
import http from "@/utils/http";
import { promised } from "q";
import filebox from "@/components/Share/Preview/fileBox";
import { mapState, mapMutations } from "vuex";
export default {
  data() {
    return {
      paramInfo: {},
      tabconfig: {
        defaultValue: 0,
        backFun: this.tabClickBackFun,
        affixNum: 0,
        tabList: [
          { key: 0, value: "申请信息" },
          { key: 1, value: "审批信息" }
        ]
      },
      leaveInfo: {},
      fileInfo: {},
      applyState: { APPRYES: "已通过", SUBMIT: "审批中", APPRNO: "拒绝" },
      columns: [
        {
          title: "请假日",
          key: "restStartDate"
        },
        {
          title: "时长",
          slot: "restTime"
        },
        {
          title: "状态",
          slot: "applyStatus"
        }
      ]
    };
  },
  computed: {
    ...mapState({
      userInfo: state => state.userInfo
    })
  },
  methods: {
    ...mapMutations(["setTitleInfo"]),
    tabClickBackFun(index) {},
    getLeaveInfo(applyId, applyTypeId) {
      let _this = this;
      this.$Spin.show();
      return new Promise((resolve, reject) => {
        http
          .get(
            `api/HR/Leave/GetLeaveApplyInfo?applyId=${applyId}&applyTypeId=${applyTypeId}`
          )
          .then(res => {
            _this.$Spin.hide();
            if (res.data && res.data.data) {
              _this.setTitleInfo({
                title: "",
                bg: res.data.data.applyStatus,
                isMore:true
              });
              _this.fileInfo = {
                filesrcs: res.data.data.certificatePath,
                filenames: res.data.data.certificateName
              };
              resolve(res.data.data || {});
            } else resolve({});
          });
      });
    }
  },
  async mounted() {
    let _this = this;
    this.$nextTick(() => {
      _this.tabconfig.affixNum = _this.$refs.tab.offsetTop;
      _this.$refs.leave_tab.style = "top:" +_this.tabconfig.affixNum  + "px";
    });
    this.paramInfo = { ...this.$route.query };
    this.leaveInfo = await this.getLeaveInfo(
      this.paramInfo.applyId,
      this.paramInfo.applyTypeId
    );
  },
  components: {
    headers,
    process,
    exefoot,
    selffoot,
    passfoot,
    tab,
    filebox
  }
};
</script>
 
<style scoped lang="less">
.leavecontent {
  .headers {
    padding: 0 0.4rem;
  }
  .headers-background-SUBMIT {
    background: #feaf0d;
  }
  .headers-background-APPRYES {
    background: #5acf32;
  }
  .headers-background-APPRNO {
    background: #fd5020;
  }
  .leave-tab {
    width: 100%;
    height: 1.44rem;
    position: sticky;
    z-index: 9;
    background: #fff;
    display: flex;
    align-items: center;
  }
  .mian {
    padding-bottom: 1.6rem;
    .leave-info {
      padding: 0 0.4rem;
      .leave-info-box {
        margin-top: 0.533333rem;
        font-size: 0.373333rem;
        display: flex;
        .leave-info-label {
          text-align: center;
          flex: 1;
          color: #999;
        }
        .leave-info-content {
          margin-left: 0.133333rem;
          width: 80%;
          color: #333333;
        }
      }
    }
    .process {
      margin-top: 0.4rem;
      padding: 0 0.4rem;
    }
  }
  .leave-foot {
    padding: 0 0.4rem;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    height: 1.6rem;
    background: #fff;
    z-index: 9;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/HR/Leave/index.vue